export const selectDistributors = (state) => state.distributor.list;
export const selectDistributorLoading = (state) => state.distributor.loading;
export const createDistributorLoading = (state) => state.distributor.createLoading;
export const selectDistributorError = (state) => state.distributor.error;
